import React from "react";
import { LOGOS, DISCORD_URL } from "../lib/api";

export const Footer = () => (
  <footer
    className="border-t border-[#9D4CDD]/25 mt-24 bg-[#0a0512]/80"
    data-testid="main-footer"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <img src={LOGOS.icon} alt="EGT" className="h-10 w-10" />
        <div>
          <div className="font-display font-bold tracking-wider">
            <span className="text-gradient-orange">ELITE</span>
            <span className="text-white">GORILLATAG</span>
          </div>
          <div className="text-xs text-white/50">
            Competitive Gorilla Tag Tournament Hub
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4 text-sm text-white/60">
        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-[#FF5E00] transition-colors"
        >
          Discord
        </a>
        <span className="text-white/20">•</span>
        <span>© {new Date().getFullYear()} EliteGorillaTag</span>
      </div>
    </div>
  </footer>
);

export default Footer;
